import { Button } from "antd";
import clsx from "clsx";

import type { SentimentOption } from "../types";

import s from "./SentimentSelector.module.css";

interface SentimentSelectorProps {
  question: string;
  options: SentimentOption[];
  value: string | null;
  onChange: (value: string) => void;
  ariaLabel?: string;
  disabled?: boolean;
}

export const SentimentSelector = ({
  question,
  options,
  value,
  onChange,
  ariaLabel = "Overall satisfaction",
  disabled = false,
}: SentimentSelectorProps) => {
  return (
    <section className={s.root}>
      <p className={s.question}>{question}</p>
      <div role="radiogroup" aria-label={ariaLabel} className={s.options}>
        {options.map((option, index) => {
          const isSelected = option.value === value;
          const isFocusable = isSelected || (value === null && index === 0);
          return (
            <Button
              key={option.value}
              type="text"
              role="radio"
              aria-checked={isSelected}
              disabled={disabled}
              tabIndex={isFocusable ? 0 : -1}
              className={clsx(s.card, isSelected && s.cardSelected)}
              data-testid={`feedback-sentiment-${option.value}`}
              onClick={() => onChange(option.value)}
              icon={
                option.emoji ? (
                  <span aria-hidden="true" className={s.emoji}>
                    {option.emoji}
                  </span>
                ) : undefined
              }
            >
              <span className={s.label}>{option.label}</span>
            </Button>
          );
        })}
      </div>
    </section>
  );
};
